import {
  Avatar,
  AvatarFallbackText,
  KeyboardAvoidingView,
  SafeAreaView,
  View,
  VStack
} from "@gluestack-ui/themed";
import { CustomHeader } from "@repo/core/components/layout/CustomHeader";
import { StatusBar } from "@repo/core/components/layout/StatusBar";
import { EditProfileController } from "./controller";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Button } from "@repo/core/components/core/Button";

function EditProfile() {
  const {
    back,
    user,
    control,
    isTabletOrWeb,
    isValid,
    isSubmitting,
    handleOnSubmitForm
  } = EditProfileController();
  return (
    <VStack flex={1} bg="$backgroundLight100" overflow="hidden" height="$100vh">
      <StatusBar barStyle="light-content" showCustomStatusBar />
      <SafeAreaView flex={1} p="$4" bg="$backgroundLight0">
        <VStack flex={1} p="$4" space="lg">
          <View px="$2">
            <CustomHeader title="Editar perfil" onBackPress={back} />
          </View>

          <VStack flex={1}>
            <VStack alignItems="center" justifyContent="center">
              <Avatar size="xl">
                <AvatarFallbackText>{user?.name}</AvatarFallbackText>
              </Avatar>
            </VStack>

            <KeyboardAvoidingView flex={1}>
              <View
                flexGrow={1}
                gap="$4"
                pt="$4"
                w={isTabletOrWeb ? 480 : "$full"}
                m={isTabletOrWeb ? "auto" : undefined}
              >
                <InputControlled
                  control={control}
                  name="fullName"
                  placeholder="Digite o nome completo"
                  size="md"
                  returnKeyType="next"
                  label="Nome"
                  isRequired
                  maxLength={100}
                />

                <InputControlled
                  control={control}
                  name="position"
                  placeholder="Digite o seu cargo"
                  size="md"
                  label="Cargo"
                  returnKeyType="next"
                  isDisabled
                />
              </View>
              <View
                gap="$4"
                flexDirection={isTabletOrWeb ? "row-reverse" : "column"}
                justifyContent={isTabletOrWeb ? "center" : "center"}
                w={isTabletOrWeb ? 480 : "$full"}
                m={isTabletOrWeb ? "auto" : undefined}
              >
                <Button
                  size="xl"
                  isDisabled={!isValid}
                  isLoading={isSubmitting}
                  action={isValid ? "primary" : "secondary"}
                  text="Salvar"
                  w={isTabletOrWeb ? "$1/2" : "$full"}
                  onPress={handleOnSubmitForm}
                />
                <Button
                  isDisabled={isSubmitting}
                  variant="outline"
                  action="negative"
                  size="xl"
                  w={isTabletOrWeb ? "$1/2" : "$full"}
                  text="Cancelar"
                  onPress={back}
                />
              </View>
            </KeyboardAvoidingView>
          </VStack>
        </VStack>
      </SafeAreaView>
    </VStack>
  );
}

export default EditProfile;
